import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  background-color: ${({ theme }) => theme.bg.secondary};
  border-bottom: 1px solid ${({ theme }) => theme.border.black10};
  align-items: center;
  z-index: 30;

  * {
    font-family: "PP Formula";
  }
`;

export const HeaderDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderHeading = styled.h1`
  margin: 0;
  font-size: 18px;
  font-weight: 100;
  color: ${({ theme }) => theme.text.title};
`;

export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
